import { hasLoggedOutCookie } from './AuthHelper';

export const LEADSTER_SSO_SKIP_PARAM = 'leadster_sso';
export const LEADSTER_SSO_SKIP_VALUE = 'skip';

// Bridge URL comes from chatwootConfig (LEADSTER_SSO_BRIDGE_URL / LEADSTER_APP_URL).
// Blank disables the automatic Leadster session check on /app/login.
// Outbound redirect is primarily handled server-side; this remains a SPA fallback.
export const getLeadsterSsoBridgeUrl = (chatwootConfig = {}) => {
  return String(chatwootConfig.leadsterSsoBridgeUrl || '').trim();
};

export const shouldAttemptLeadsterSso = (to, chatwootConfig = {}) => {
  if (to?.name !== 'login') return false;
  if (to.query?.email && to.query?.sso_auth_token) return false;
  if (to.query?.[LEADSTER_SSO_SKIP_PARAM] === LEADSTER_SSO_SKIP_VALUE) {
    return false;
  }
  // Logout sets this so the next /app/login does not bounce through the
  // Leadster bridge while that session is still valid.
  if (hasLoggedOutCookie()) return false;
  if (!getLeadsterSsoBridgeUrl(chatwootConfig)) return false;

  return true;
};

export const buildLeadsterSsoReturnToUrl = () => {
  const returnUrl = new URL('/app/login', window.location.origin);
  returnUrl.searchParams.set(LEADSTER_SSO_SKIP_PARAM, LEADSTER_SSO_SKIP_VALUE);
  return returnUrl.toString();
};

export const buildLeadsterSsoBridgeRedirectUrl = (chatwootConfig = {}) => {
  const bridgeUrl = getLeadsterSsoBridgeUrl(chatwootConfig);
  if (!bridgeUrl) return null;

  const url = new URL(bridgeUrl);
  url.searchParams.set('return_to', buildLeadsterSsoReturnToUrl());
  return url.toString();
};

export const redirectToLeadsterSsoBridge = (chatwootConfig = {}) => {
  const redirectUrl = buildLeadsterSsoBridgeRedirectUrl(chatwootConfig);
  if (!redirectUrl) return false;

  window.location.replace(redirectUrl);
  return true;
};
